(() => {
 'use strict';
 if(window.__ps3LiveLoader)return;window.__ps3LiveLoader=true;
 const node=document.getElementById('PS3Config');if(!node)return;
 let config;try{config=JSON.parse(node.textContent);}catch{return;}
 if(config.demo)return;
 let loading;
 function script(src){return new Promise((resolve,reject)=>{if(!src){reject(new Error('Missing runtime asset'));return;}const s=document.createElement('script');s.src=src;s.onload=resolve;s.onerror=()=>{s.remove();reject(new Error('Runtime asset unavailable'));};document.head.append(s);});}
 function load(){if(window.__patinaV5)return Promise.resolve();if(!loading)loading=(window.PatinaMatcher?Promise.resolve():script(config.matcherScript)).then(()=>script(config.runtimeScript)).catch(error=>{loading=null;throw error;});return loading;}
 function init(root=document){
  const brief=new URLSearchParams(location.search).get('brief');
  if(brief)root.querySelectorAll?.('[data-ps3-sourcing-notes]').forEach(input=>{if(!input.value)input.value=brief.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g,'').slice(0,4000);});
  if(!root.querySelector?.('[data-ps3-live-finder]')&&!root.matches?.('[data-ps3-live-finder]'))return;
  load().catch(()=>{root.querySelectorAll?.('[data-ps3-live-finder]').forEach(el=>{el.textContent='The guided finder could not load. Please refresh the page or browse Walnut Pairs from the Shop menu.';});});
 }
 document.addEventListener('click',event=>{
  const trigger=event.target.closest?.('[data-ps3-video],[data-ps3-zoom],[data-ps3-scroll]');
  if(!trigger||window.__patinaV5)return;
  event.preventDefault();event.stopImmediatePropagation();trigger.setAttribute('aria-busy','true');
  load().then(()=>{if(trigger.isConnected)trigger.click();}).catch(()=>{
   let status=document.getElementById('PS3LoadStatus');if(!status){status=document.createElement('p');status.id='PS3LoadStatus';status.setAttribute('role','alert');trigger.after(status);}status.textContent='This viewer could not load. Please try again.';
  }).finally(()=>trigger.removeAttribute('aria-busy'));
 },true);
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
